import script from "./banjiduotiao.vue?vue&type=script&setup=true&lang=js"
export * from "./banjiduotiao.vue?vue&type=script&setup=true&lang=js"

import "./banjiduotiao.vue?vue&type=style&index=0&id=c684ec0e&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c684ec0e"]])

export default __exports__